import React from 'react';
import { cn } from './utils';

export interface EmptyStateProps {
  icon?: React.ReactNode;
  title: React.ReactNode;
  description?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}

export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div className={cn('bh-empty', className)}>
      {icon ? <div className="bh-empty__icon">{icon}</div> : null}
      <h3 className="bh-empty__title">{title}</h3>
      {description ? <p className="bh-empty__desc">{description}</p> : null}
      {action ? <div className="bh-empty__action">{action}</div> : null}
    </div>
  );
}
